import AccountIncreaseCredit from './AccountIncreaseCredit';
import { withI18n } from 'react-i18next';

export const pureComponent = AccountIncreaseCredit;
export default withI18n()(AccountIncreaseCredit);
